export { default } from './Transfer'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/Transfer/index.js